<div class="card">
    <div class="card-body">

        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h3>Promociones</h3>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="card-layout">
    <div class="card-deck"  >
        <div class="col-md-3" *ngFor="let p of promociones">
          <div  class="card" style="margin-bottom: 12px;" >
            <img class="card-img-top" src="assets/images/promociones/promocion1.jpg" alt="Promocion" />
            <div class="card-body">
              <h4 class="card-title">{{p.nombreEmpresa}}</h4>
              <p class="card-text">
              {{p.nombrePromocion}}
              </p>
            </div>
            <div class="card-footer">
              <small class="text-muted">Vigencia: {{p.inicioVigencia}} - {{p.finVigencia}}</small>
            </div>
          </div> 
        </div>               
    </div>
</section>